import { useTranslation } from 'react-i18next';

export default function FaultFilters({ filters, onFiltersChange }) {
  const { t } = useTranslation();

  const handleChange = (key, value) => {
    onFiltersChange((prev) => ({ ...prev, [key]: value }));
  };

  const activeFilterCount = Object.values(filters).filter((v) => v !== 'all' && v !== 'newest').length;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-gray-900">{t('faultReports.filters')}</h3>
        {activeFilterCount > 0 &&
        <button
          onClick={() => onFiltersChange({ scope: 'all', status: 'all', category: 'all', priority: 'all', sortBy: 'newest' })}
          className="text-sm text-blue-600 hover:text-blue-700">
            {t('faultReports.clearAll')}
          </button>
        }
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {/* Scope */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">{t('faultReports.scope')}</label>
          <select
            value={filters.scope}
            onChange={(e) => handleChange('scope', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent">
            <option value="all">{t('common.all')}</option>
            <option value="property">{t('faultReports.propertyWide')}</option>
            <option value="building">{t('faultReports.myBuilding')}</option>
          </select>
        </div>

        {/* Status */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">{t('faultReports.status')}</label>
          <select
            value={filters.status}
            onChange={(e) => handleChange('status', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent">
            <option value="all">{t('common.all')}</option>
            <option value="New">{t('faultReports.statusNew')}</option>
            <option value="Acknowledged">{t('faultReports.statusAcknowledged')}</option>
            <option value="InProgress">{t('faultReports.statusInProgress')}</option>
            <option value="Waiting">{t('faultReports.statusWaiting')}</option>
            <option value="Resolved">{t('faultReports.statusResolved')}</option>
            <option value="Closed">{t('faultReports.statusClosed')}</option>
          </select>
        </div>

        {/* Category */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">{t('faultReports.category')}</label>
          <select
            value={filters.category}
            onChange={(e) => handleChange('category', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent">
            <option value="all">{t('common.all')}</option>
            <option value="Electrical">{t('faultReports.categoryElectrical')}</option>
            <option value="Plumbing">{t('faultReports.categoryPlumbing')}</option>
            <option value="Elevator">{t('faultReports.categoryElevator')}</option>
            <option value="Painting">{t('faultReports.categoryPainting')}</option>
            <option value="Landscaping">{t('faultReports.categoryLandscaping')}</option>
            <option value="Security">{t('faultReports.categorySecurity')}</option>
            <option value="Other">{t('faultReports.categoryOther')}</option>
          </select>
        </div>

        {/* Priority */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">{t('faultReports.priority')}</label>
          <select
            value={filters.priority}
            onChange={(e) => handleChange('priority', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent">
            <option value="all">{t('common.all')}</option>
            <option value="Low">{t('faultReports.priorityLow')}</option>
            <option value="Medium">{t('faultReports.priorityMedium')}</option>
            <option value="High">{t('faultReports.priorityHigh')}</option>
            <option value="Urgent">{t('faultReports.priorityUrgent')}</option>
          </select>
        </div>

        {/* Sort */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">{t('faultReports.sortBy')}</label>
          <select
            value={filters.sortBy}
            onChange={(e) => handleChange('sortBy', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent">
            <option value="newest">{t('faultReports.newest')}</option>
            <option value="priority">{t('faultReports.sortByPriority')}</option>
            <option value="status">{t('faultReports.sortByStatus')}</option>
          </select>
        </div>
      </div>
    </div>
  );
}